// extracted by mini-css-extract-plugin
export default {"container":"container__xq9-Z","img":"img__uBL3+","title":"title__45vzr","message":"message__fLw02"};